module.exports = __webpack_public_path__ + "static/media/Sara Yerkes Headshot.12572dc3.jpeg";